import { Outlet } from 'react-router-dom';

import Grid from 'components/Grid';
import OnboardingTopBar from 'components/OnboardingTopBar';
import OnboardingContent from 'components/containers/OnboardingContent';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const OnboardingLayout: FunctionComponent<Props> = ({ testId = TEST_ID }) => (
    <Grid className={styles.onboardingLayout} testId={testId}>
        <OnboardingTopBar className={styles.onboardingTopBar} />

        <OnboardingContent className={styles.onboardingContent}>
            <Outlet />
        </OnboardingContent>
    </Grid>
);

export default OnboardingLayout;
